import { __assign } from "tslib";
import { isType } from '@antv/util';
/**
 * tooltip formatter
 * @param {any} tooltipOptions
 * @param {boolean} isPercent
 */
export function transformTooltip(tooltipOptions, isPercent) {
    // customContent 优先级高于 formatter
    if (!isType(tooltipOptions, 'Object') || (tooltipOptions === null || tooltipOptions === void 0 ? void 0 : tooltipOptions.customContent)) {
        return tooltipOptions;
    }
    var tooltip = __assign({}, tooltipOptions);
    if (tooltip.formatter || isPercent) {
        tooltip.customContent = function (value, items) {
            return getTooltipTemplate({
                value: value,
                items: items,
                formatter: tooltip.formatter,
                isPercent: isPercent,
            });
        };
    }
    return tooltip;
}
/**
 * formatter value
 * @param {string} value
 * @param {any[]} items
 * @param {Function} formatter
 * @param {boolean} isPercent
 * @returns HTMLElement
 */
export function getTooltipTemplate(params) {
    var value = params.value, items = params.items, formatter = params.formatter, isPercent = params.isPercent;
    var container = document.createElement('div');
    container.className = 'g2-tooltip';
    var title = "<h4>" + value + "</h4>";
    var listItem = '';
    var formatterItem = function (item) {
        if (formatter) {
            return formatter(item);
        }
        if (isPercent) {
            return ((item === null || item === void 0 ? void 0 : item.value) * 100).toFixed(2) + '%';
        }
        return item === null || item === void 0 ? void 0 : item.value;
    };
    items.forEach(function (item) {
        var _a;
        listItem += "<li class=\"g2-tooltip-list-item\" data-index={index} style=\"margin-bottom:4px;display:flex;\">\n        <span style=\"background-color:" + ((_a = item.mappingData) === null || _a === void 0 ? void 0 : _a.color) + ";\" class=\"g2-tooltip-marker\"></span>\n        <span style=\"display:inline-flex;flex:1;justify-content:space-between\">\n        <span style=\"margin-right: 16px;\">" + item.name + ":</span><span>" + formatterItem(item) + "</span>\n        </span>\n    </li>";
    });
    container.innerHTML = title + listItem;
    return container;
}
//# sourceMappingURL=tooltip.js.map